export default "__VITE_ASSET__17040b0c__"